export default __webpack_public_path__ + "static/media/munnar3.ca97ed73.jpg";